import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { MatomoTracker } from 'ngx-matomo';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, } from '@angular/common/http';
import { ChartOptions } from 'src/app/shared/classes/chart-options';
import { DisabledTimeFn, DisabledTimePartial, NzDatePickerComponent } from 'ng-zorro-antd/date-picker';



@Component({
  selector: 'app-WmsmMaintainVenderABTypeComponent',
  templateUrl: './wmsm-MaintainVenderABType.html',
  styleUrls: ['./wmsm-MaintainVenderABType.scss']

})


export class WmsmMaintainVenderABTypeComponent extends BaseComponent implements OnInit {
  loading: boolean = false;
  validateForm: FormGroup;
  validateFormType: any[];
  SiteList: any;
  pageIndex: number = 1;
  pageSize: number = 20;
  nzTotal: number = 0;
  listOfData: any;
  editData: any;
  isEdit: boolean = false;
  @Input() show: boolean;
  @Input() ShowSite: boolean = true;

  @ViewChild('endDatePicker') endDatePicker!: NzDatePickerComponent;
  ExcelControl = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];
  data: any;
  onChange(result: Date[]): void {
  }

  etWeek(result: Date[]): void {
  }

  constructor(private fb: FormBuilder,
    private Environment: EnvironmentconfigService,
    private webApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private chart: ChartOptions) { super() };

  ngOnInit(): void {

    this.validateForm = this.fb.group({
      Site:[['']],
      Vendor:[['']],
      DataDateFrom: [],
      FormType: [[]],
      VendorType: [['']],
      nzValueDate: [""],
      nzValueDateone: [['']],
    });

  }

  onSearch() {

   
  }
  
  onEdit(data) {
    this.editData = { ...data };
    this.isEdit = true;
  }

}







